import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {Emitters} from '../helpers/core/emitters';
import {ScriptLoaderService} from '../services/script-loader.service';
import {GoogleApiLoader} from '../helpers/jquery/google.api.loader';
import {BaseUrls} from '../helpers/core/base.urls';
import {RequestUrls} from '../helpers/routes/request.urls';
import {HttpRequests} from '../helpers/core/http.requests';
import {DeleteComponent} from '../models/delete/delete.component';
import {DatePickerDirective} from '../directives/date-picker/date-picker.directive';
import {TimePickerDirective} from '../directives/date-picker/time-picker.directive';
import {DateTimePickerDirective} from '../directives/date-time-picker/date-time-picker.directive';
import {SpectrumColorPickerDirective} from '../directives/spectrum-color/spectrum-color.picker.directive';
import {SelectorTwoDirective} from '../directives/select2/selector-two.directive';
import {Select2IconDirective} from '../directives/select2/select2-icon.directive';
import {FilterPipe} from '../pipe/filter.pipe';
import {NgPipesModule} from 'ngx-pipes';
import {TimePipe} from '../pipe/time.pipe';
import {NumericDirective} from '../directives/numeric-directive/numeric.directive';
import {DateRangePickerDirective} from '../directives/date-range-picker/date.range.picker.directive';
import {HttpHelper} from '../helpers/core/http.helper';
import {TemplateHelper} from '../helpers/core/template.helper';
import {RequestHelperUrl} from '../helpers/routes/request.helper.url';
import {BaseHelperUrl} from '../helpers/routes/base.helper.url';
import {PaginationComponent} from '../pages/pagination/pagination.component';
import {CommonModule} from '@angular/common';
import {UserReportComponent} from '../pages/authenticated/reports/uesr/user.report.component';
import {AssetReportComponent} from '../pages/authenticated/reports/asset/asset.report.component';
import {NRReportComponent} from '../pages/authenticated/reports/nr/nr.report.component';
import {LiveAssetReportComponent} from '../pages/authenticated/reports/live-asset/live.asset.report.component';
import {DistanceReportComponent} from '../pages/authenticated/reports/distance/distance.report.component';
import { ParkReportComponent } from '../pages/authenticated/reports/park-maintenance/park.report.component';
import { EndDateTimePickerDirective } from '../directives/end-date-time-picker/date-time-picker.directive';
import { OddHoursComponent } from '../models/odd-hours/odd-hours.component';

@NgModule({
    declarations: [
        DeleteComponent,
        OddHoursComponent,
        DatePickerDirective,
        TimePickerDirective,
        DateTimePickerDirective,
        EndDateTimePickerDirective,
        DateRangePickerDirective,
        SelectorTwoDirective,
        Select2IconDirective,
        SpectrumColorPickerDirective,
        FilterPipe,
        TimePipe,
        NumericDirective,
        PaginationComponent,
        UserReportComponent,
        AssetReportComponent,
        NRReportComponent,
        LiveAssetReportComponent,
        DistanceReportComponent,
        ParkReportComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FormsModule,
        NgxPaginationModule,
        DeleteComponent,
        OddHoursComponent,
        DatePickerDirective,
        TimePickerDirective,
        DateTimePickerDirective,
        EndDateTimePickerDirective,
        DateRangePickerDirective,
        SelectorTwoDirective,
        Select2IconDirective,
        SpectrumColorPickerDirective,
        NgPipesModule,
        FilterPipe,
        TimePipe,
        NumericDirective,
        PaginationComponent,
        UserReportComponent,
        AssetReportComponent,
        NRReportComponent,
        LiveAssetReportComponent,
        DistanceReportComponent,
        ParkReportComponent,
    ],
    providers: [
        Emitters,
        RequestUrls,
        HttpRequests,
        BaseUrls,
        ScriptLoaderService,
        GoogleApiLoader,
        HttpHelper,
        TemplateHelper,
        RequestHelperUrl,
        BaseHelperUrl
    ]
})
export class SharedModule {
}
